window.eligibilityMeter = function (s, t) {
    return {
        score: null,
        scoreText: null,
        rating: null,
        needleDegreeOffset: 213,
        needleRotate(){ 
            return this.needleDegreeOffset + ((this.rating - 1) * 180/5);
        },
        getRatingColor() {
            return {
                1: '#C1272D',
                2: '#F15A24',
                3: '#FBB03B',
                4: '#FCEE21',
                5: '#7AC943',
                6: '#009245',
            }[this.rating] || null;
        },
        init(s, t, r) {
            setTimeout(() => {
                this.score = s;
                this.scoreText = t;
                this.rating = r;
                this.$el.classList.add('in');
            }, 3000);
        },
        arrowStyles() {
            return {
                opacity: this.customer.normalizedScore > 1 ? 1 : 0,
                transform:
                    'rotate(' +
                    (this.customer.normalizedScore * this.segmentDegree +
                        this.rotateOffset) +
                    'deg)',
                // "transition-delay": '1000ms',
                'transition-duration':
                    (this.customer.normalizedScore || 0) * (1 / 6) + 's',
            }
        }
    }
};